import { Course } from './types';

// The "group price" is the full-course price shared by the most courses in a
// certificate group. It is what the group price header displays. A course whose
// price differs from this shows its own price inline on its card
export function getGroupFullCoursePrice(courses: Course[]): number | undefined {
  const counts = new Map<number, number>();
  for (const course of courses) {
    counts.set(course.fullCoursePrice, (counts.get(course.fullCoursePrice) ?? 0) + 1);
  }

  let groupPrice: number | undefined;
  let bestCount = 0;
  for (const [price, count] of Array.from(counts.entries())) {
    if (count > bestCount) {
      bestCount = count;
      groupPrice = price;
    }
  }

  return groupPrice;
}

export function priceDiffersFromGroup(
  course: Course,
  groupFullCoursePrice: number | undefined,
): boolean {
  return groupFullCoursePrice != null && course.fullCoursePrice !== groupFullCoursePrice;
}
